import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useCouponsStore } from 'src/store/benefits/coupons.store';
import { useNavigate } from 'react-router';
import { paths } from 'src/routes/paths';
import { useSnackbar } from 'notistack';

type Props = {
  hook: any;
};

export default function ApproveDialog({ hook }: Props) {
  const { approveLPCoupon } = useCouponsStore();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const handleApprove = async () => {
    await approveLPCoupon(hook?.id!);
    hook.onCloseApprove();
    navigate(paths.dashboard.lpCouponsList);
    enqueueSnackbar('Cupom aprovado com sucesso!', { variant: 'success' });
  };
  return (
    <Dialog maxWidth="sm" fullWidth open={hook.openApprove} onClose={hook.onCloseApprove}>
      <DialogTitle>Confirmação</DialogTitle>
      <DialogContent>
        <Typography>Tem certeza que deseja aprovar este cupom?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={hook.onCloseApprove} color="inherit">
          Cancelar
        </Button>
        <LoadingButton onClick={() => handleApprove()} type="submit" variant="contained">
          Confirmar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
